<div class="game-dashboard-block statistics-block">
  <div class="statistics-block__headline">
    <brt-dashboard-boxes-head [data]="data.headlineData"></brt-dashboard-boxes-head>
  </div>

  <div class="statistics-block__content">
    <div class="statistics-block__chart" *ngIf="data.addChart && pieChartData.datasets.length > 0">
      <brt-chart (onIndexHover)="onItemChartHovered($event)" (onIndexHoverOut)="onItemChartHoverOut()" [data]="chartData"></brt-chart>
    </div>

    <div class="statistics-block__data">
      <div class="statistics-block__item" *ngFor="let item of data.items; index as idx" [ngClass]="{'highlighted': idx === highlightedItemIdx}">
        <div class="statistics-block__item-image" *ngIf="item.image"></div>
        <div class="statistics-block__item-color-dot" *ngIf="item.color && item.color.length > 0" [ngStyle]="{'background-color': item.color}"></div>

        <div class="statistics-block__item-title">{{item.title}}</div>

        <div class="statistics-block__item-value-wrapper">
          <div class="statistics-block__item-value-difference" *ngIf="item.difference !== 0" [ngClass]="[item.difference > 0 ? 'positive' : 'negative']">
            <span class="statistics-block__item-value-difference-arrow-up">↑</span><span class="statistics-block__item-value-difference-arrow-down">↓</span> {{item.difference| number}}%
          </div>

          <div class="statistics-block__item-value">{{item.value}}{{item.valueUnit}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
